import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function ProductCard({ product }) {
    return (
        <div className="flex flex-col rounded-lg overflow-hidden bg-[#F3F3F3]">
            <div className="w-full aspect-square rounded-lg overflow-hidden">
                <img className='size-full object-cover' src={getCachedMediaUrl(product.VarientImgUrl[0])} alt={product.VarientName} />
            </div>

            <div className="p-2 pb-4 flex flex-col">
                <div className='flex items-center gap-1'>
                    <p className='font-semibold text-[10.76px] leading-[17.22px] text-[#000000]'>₹{product.VarientPrice}</p>

                    {
                        product.VarientMrp > product.VarientPrice && 
                        <>
                            <p className='font-semibold text-[8px] leading-[14px] text-[#666666] line-through'>₹{product.VarientMrp}</p>

                            <p className='font-medium text-[6.46px] leading-[13px] text-primaryColor'>{Math.round(((product.VarientMrp - product?.VarientPrice) / product.VarientMrp) * 100).toFixed(0)}% off</p>
                        </>
                    }
                </div>

                <p className='font-semibold text-[8px] leading-[14px] text-[#000000] line-clamp-1'>{product.VarientName}</p>

                <p className='line-clamp-1 font-medium text-[6.46px] leading-[13px] text-[#666666]'>{product.prodDesc}</p>
            </div>
        </div>
    )
}

export default ProductCard;
